import React, { ReactNode } from 'react';
import { MidHeading, Text, TextProps } from '../../typography';
import {
  HeaderSubHeading,
  HeaderTitle,
  IconItem,
  IconsGrid,
  PageHeader,
  PageHeaderWrapper,
  TabsContainer,
  Tabs,
  IconContainer,
} from './ProductsPageHeader.style';

export interface ProcutsHeaderIcon {
  SVG?: string;
  src?: string;
  heading: string;
  text?: string | React.ReactNode;
  link?: React.ReactNode;
  maxW?: number;
  headingSize?: number;
  headingMaxW?: number;
  headingMt?: number;
  headingWeight?: string;
  textSize?: number;
  textMt?: number;
}

interface ProductsPageHeaderProps {
  title: string;
  text: string;
  icons?: ProcutsHeaderIcon[];
  headingProps?: TextProps;
  subHeadingProps?: TextProps;
  icon?: React.ReactNode;
  iconsColumnGap?: number;
  pb?: number;
  maxW?: number;
  children?: ReactNode;
  iconsJustifyCenter?: boolean;
}

const ProductsPageHeader: React.FC<ProductsPageHeaderProps> = ({
  title,
  text,
  headingProps,
  subHeadingProps,
  icons,
  icon,
  iconsColumnGap,
  pb,
  maxW,
  children,
  iconsJustifyCenter,
}) => {
  return (
    <PageHeader hasIcons={!!icons} pb={pb}>
      <PageHeaderWrapper maxW={maxW}>
        <TabsContainer>
          <Tabs />
        </TabsContainer>
        {icon && <IconContainer data-testid="product-header-icon">{icon}</IconContainer>}
        <HeaderTitle data-testid="product-header" fontSize={44} mb={40} {...headingProps}>
          {title}
        </HeaderTitle>
        <HeaderSubHeading
          data-testid="product-subheader"
          fontSize={22}
          fontWeight="normal"
          mb={70}
          autoMargin
          maxWidth={620}
          {...subHeadingProps}
        >
          {text}
        </HeaderSubHeading>
        {icons && icons.length > 0 && (
          <IconsGrid columnGap={iconsColumnGap} iconsJustifyCenter={iconsJustifyCenter}>
            {icons.map(
              ({
                SVG,
                src,
                heading,
                text: iconText,
                maxW: maxWidth,
                headingSize,
                headingMaxW,
                headingMt,
                headingWeight,
                textSize,
                textMt,
                link,
              }) => (
                <IconItem
                  key={(typeof iconText === 'string' ? iconText : heading) || heading}
                  maxW={maxWidth}
                  headingSize={headingSize}
                  headingMaxW={headingMaxW}
                  headingMt={headingMt}
                  headingWeight={headingWeight}
                  textSize={textSize}
                  textMt={textMt}
                  data-testid="product-header-grid-icon"
                >
                  {SVG && <SVG />}
                  {src && <img src={src} alt={heading} data-testid="product-header-grid-img" />}
                  <div>
                    <MidHeading>{heading}</MidHeading>
                    {iconText && <Text data-testid="product-header-grid-icon-text">{iconText}</Text>}
                    {link}
                  </div>
                </IconItem>
              ),
            )}
          </IconsGrid>
        )}
        {children}
      </PageHeaderWrapper>
    </PageHeader>
  );
};

export default ProductsPageHeader;
